import React from "react";

import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Flex, Button, Text, Box } from "@chakra-ui/react";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();
import { ImageAutoHeight } from "@/components/common/Image";
import Link from "next/link";
import { GetStaticProps } from "next";
import LanguageSwitcher from "@/components/Layout/Header/LanguageSwitcher";

export const Custom404Page = (): React.ReactElement => {
  const { t } = useTranslation("common");

  return (
    <Box maxW="1536px" mx="auto">
      <Flex minH="100vh" justify="center" align="center">
        <Box mr="5rem" w="450px">
          <ImageAutoHeight
            src={`${publicRuntimeConfig.basePath}/login.svg`}
            layout="fill"
            alt="Main Image"
          />
        </Box>
        <Box color="white">
          <Flex justifyContent="space-between" alignItems="center">
            <Text fontSize="6rem" fontWeight="500" lineHeight="1">
              404
            </Text>
            <LanguageSwitcher />
          </Flex>
          <Text
            fontSize="1.875rem"
            mt="1.25rem"
            fontWeight="500"
            lineHeight="2.25rem"
          >
            {t("error.pageNotFound")}
          </Text>
          <Text fontSize="1.125rem" mt=".75rem" lineHeight="1.75rem">
            {t("error.wrongURL")}
          </Text>
          <Link href="/">
            <Button variant="dark" size="xl" mt="2.5rem">
              {t("error.back")}
            </Button>
          </Link>
        </Box>
      </Flex>
    </Box>
  );
};

export const getStaticProps: GetStaticProps = async (ctx) => ({
  props: {
    ...(await serverSideTranslations(ctx.locale, ["common"])),
  },
});

export default Custom404Page;
